import { BarChartIcon, HeartIcon, ShieldLockIcon } from '@navikt/aksel-icons';
import type { SurveyModule } from '../../../domain/surveys/survey-list';
import classes from '../SurveysPage.module.css';

const icons = {
  psychologicalSafety: ShieldLockIcon,
  workEnvironment: HeartIcon,
  custom: BarChartIcon,
} satisfies Record<SurveyModule, unknown>;

/** Ikonet for modulen. Dekorativt: modulnavnet står alltid ved siden av. */
export const ModuleIcon = ({ module }: { module: SurveyModule }) => {
  const Icon = icons[module];
  return (
    <span aria-hidden="true" className={classes.moduleIcon}>
      <Icon />
    </span>
  );
};
